import {
  QuickLoginPromptTrackingPoint,
  ReloginQuickLoginTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const QuickLoginPromptTrackingSchema: Record<
  QuickLoginPromptTrackingPoint,
  string
> = {
  [QuickLoginPromptTrackingPoint.QuickLoginPromptPageView]:
    '0dec64a1-78e9-4a57-8d28-40544eb5ddb0',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptEnableQuickLoginClick]:
    '65749682-82a6-47ca-8165-32c6d16423d5',
  [QuickLoginPromptTrackingPoint.QuickLoginPromptBackClick]:
    'b2c5e1c5-f73f-4d74-b562-cbb1a910f186',
};

const ReloginQuickLoginTrackingSchema: Record<
  ReloginQuickLoginTrackingPoint,
  string
> = {
  [ReloginQuickLoginTrackingPoint.PageView]:
    '9ddfb758-fca3-4e29-b225-cb0d4294f5c0',
  [ReloginQuickLoginTrackingPoint.ReloginWithOtherMethodsClick]:
    'b468402c-3804-450d-b745-21ba7b2bafc3',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionImpression]:
    'f0876b8c-3b73-42ea-8d80-84bc814b55f4',
  [ReloginQuickLoginTrackingPoint.LoginWithOtherMethodsSelectionClick]:
    '13426fe5-386a-4fc0-be01-ca94017e9f86',
  [ReloginQuickLoginTrackingPoint.ReloginWithAnotherAccountClick]:
    '17796f8d-0974-476c-8490-5d1056c8d4ef',
  [ReloginQuickLoginTrackingPoint.ReloginSignupClick]:
    '6b6ea65-41ca-4c20-86e8-138cd7164126',
};

export const getQuickLoginPromptPageTypeAndSchema = (
  trackingPoint: QuickLoginPromptTrackingPoint
) => {
  return {
    page_type: PageType.QuickLoginPromptPage,
    schema: QuickLoginPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginQuickLoginPageTypeAndSchema = (
  trackingPoint: ReloginQuickLoginTrackingPoint
) => {
  return {
    page_type: PageType.ReloginQuickLoginPage,
    schema: ReloginQuickLoginTrackingSchema[trackingPoint],
  };
};
